import axios from 'axios';
import Swal from 'sweetalert2';
import {
    buttonProcessGet, responseGet, globalSettings, setBadgeStatusGeneric, dateTimeFormatGlobalSet, isUndNullEmp, sendMessageCloseCurrentWindowAsync,
} from '../../helpers/settings';
import { userModelGet } from '../../models/users/user';
import { GlobalFormats } from '../../classes/main/globalFormats';

let result = {};
let dataObj = {};
let headerObj = {};
let msgTextObj = '';
let swalProperties = {}

const { app, colors, icons, labels, messages, react, } = globalSettings;
const { backend, } = app;
const { sweetAlert2, } = react;

//#region show modal
export const userRegisterResetPostAsync = async ({
    user = {},
    dtUsers = {},
    rowIndex = 0,
    auth = {},
    languageObj = GlobalFormats?.class(),
    subMethod = '',
}) => {
    const currentMethod = 'userRegisterResetShowModalGetAsync';
    let response = responseGet();
    try {
        //#region variables
        let msgTextLocal = '';
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            //responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region show message
        //#region define message
        response = await userMessageGetAsync({
            msgText: '',
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            languageId: languageObj?.id,
            subMethod: currentMethod
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response
        }

        msgTextLocal = response?.result || '';
        //#endregion define message

        msgTextObj = {
            one: `${messages?.doYouWantRestoreTheRegistry?.[languageObj?.id]}<br/><br/>`,
            two: msgTextLocal,
            three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
        };

        swalProperties = {
            icon: sweetAlert2?.icons?.warning,
            title: labels?.warning?.[languageObj?.id],
            html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
            timer: null,
            backdrop: true,
            confirmButtonColor: colors?.warningColorExp,
            confirmButtonText: labels?.yes?.[languageObj?.id],
            showCancelButton: true, //!Swal.isLoading(), //true,
            cancelButtonColor: colors?.successColorExp,
            cancelButtonText: labels?.no?.[languageObj?.id],
            showLoaderOnConfirm: true,
            didOpen: () => {
                Swal.hideLoading();
            },
            preConfirm: async () => {
                try {
                    Swal.getCancelButton().hidden = true;
                    Swal?.update({
                        icon: sweetAlert2?.icons?.info,
                        title: `${messages?.processing?.[languageObj?.id]}...`,
                        html: `${msgTextObj?.two}`,
                        showConfirmButton: false,
                    });

                    //#region user update
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    user = {
                        ...user,
                        roleId: '',
                        emailVerified: false,
                        accountApproved: false,
                    };

                    dataObj = {
                        user: user,
                        partialUpdate: true,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${user?.id}`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        return response;
                    }

                    user = response?.result?.userVzLa || {};
                    //#endregion update user

                    //#region update row data table
                    response = userProcessButtonsGet({
                        user: user,
                        languageObj: languageObj,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        return response;
                    }

                    const processButtonsData = response?.result || [];

                    dtUsers?.row(rowIndex)?.data(processButtonsData)?.draw(true);
                    //#endregion update row data table

                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 0,
                        msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                } catch (ex) {
                    //#region Error
                    response.isSuccess = false;
                    response.msgType = -1;
                    response.msgText = `Method: ${currentMethod}<br/>`;
                    response.msgText += `Error: ${ex?.message}`;
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                    });
                    //#endregion Error
                }
            },
            allowOutsideClick: () => !Swal.isLoading(),
        };

        await Swal.fire(swalProperties);
        //#endregion show message 
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

//#region old code
// export const setEmailVerificationGetShowModalAsync = async (user = {}, dtUsers, rowIndex = 0, auth = {}) => {
//     let response = responseGet();
//     try {
//         //#region set message

//         let localMsgText = `${!user.emailVerified ? messages?.doYouWantConfirmTheEmail.es : messages?.doYouWantRemoveTheConfirmationFromEmail.es}<br/>`;
//         localMsgText += `${labels?.user.es}:<br/>`;
//         localMsgText += `<b>${user.email}</b>`;

//         //#endregion set message

//         //#region show message

//         swalProperties = {
//             icon: sweetAlert2?.icons?.warning,
//             title: labels?.warning.es,
//             html: localMsgText,
//             timer: null,
//             confirmButtonColor: globalSettings?.colors?.warningColorExp,
//             confirmButtonText: labels?.yes.es,
//             showCancelButton: true,
//             cancelButtonColor: globalSettings?.colors?.successColorExp,
//             cancelButtonText: labels?.no.es,
//             didOpen: () => {
//                 Swal.hideLoading();
//             },
//         };

//         const { dismiss, isConfirmed, isDenied, } = await Swal.fire(swalProperties);

//         //#endregion show message

//         //#region Evaluate result

//         if (isConfirmed) {
//             sendMessage(2, messages?.processing.es, globalSettings?.timers?.thirtySeconds, false, true, null, '');
//             response = await setEmailVerificationPostAsync(user, dtUsers, rowIndex, auth);
//         } else if (dismiss === globalSettings?.sweetAlert2?.dismiss?.cancel) {
//             response.msgType = -2;
//             response.msgText = '';
//             response.result = { dismiss, isConfirmed, isDenied, };
//         }

//         //#endregion Evaluate result
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: setEmailVerificationGetShowModalAsync</br>`;
//         response.msgText += `Error: ${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

export const userEmailVerificationSendPostAsync = async ({
    user = {},
    dtUsers = {},
    rowIndex = 0,
    auth = {},
    languageObj = GlobalFormats?.class(),
    subMethod = '',
}) => {
    const currentMethod = 'userEmailVerificationSendPostAsync';
    let response = responseGet();
    try {
        //#region variables
        let msgTextLocal = '';
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            //responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region show message
        //#region define message
        response = await userMessageGetAsync({
            msgText: '',
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            languageId: languageObj?.id,
            subMethod: currentMethod
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response
        }

        msgTextLocal = response?.result || '';
        //#endregion define message

        msgTextObj = {
            one: `${messages?.doYouWantSendTheConfirmationEmail?.[languageObj?.id]}<br/><br/>`,
            two: msgTextLocal,
            //three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            three: ``,
        };

        swalProperties = {
            icon: sweetAlert2?.icons?.warning,
            title: labels?.warning?.[languageObj?.id],
            html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
            timer: null,
            backdrop: true,
            confirmButtonColor: colors?.warningColorExp,
            confirmButtonText: labels?.yes?.[languageObj?.id],
            showCancelButton: true, //!Swal.isLoading(), //true,
            cancelButtonColor: colors?.successColorExp,
            cancelButtonText: labels?.no?.[languageObj?.id],
            showLoaderOnConfirm: true,
            didOpen: () => {
                Swal.hideLoading();
            },
            preConfirm: async () => {
                try {
                    Swal.getCancelButton().hidden = true;
                    Swal?.update({
                        icon: sweetAlert2?.icons?.info,
                        title: `${messages?.processing?.[languageObj?.id]}...`,
                        html: `${msgTextObj?.two}`,
                        showConfirmButton: false,
                    });

                    //#region user update
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        id: user?.id,
                        email: user?.email,
                        firstName: user?.firstName,
                        lastName: user?.lastName,
                        languageId: languageObj?.id,
                        languageCode: languageObj?.code,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlAccounts}/${backend?.methods?.sendEmailVerification}`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        return response;
                    }

                    user = response?.result?.userVzLa || {};
                    //#endregion user update

                    //#region update row data table
                    response = userProcessButtonsGet({
                        user: user,
                        languageObj: languageObj,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        return response;
                    }

                    const processButtonsData = response?.result || [];

                    dtUsers?.row(rowIndex)?.data(processButtonsData)?.draw(true);
                    //#endregion update row data table

                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 0,
                        msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                } catch (ex) {
                    //#region Error
                    response.isSuccess = false;
                    response.msgType = -1;
                    response.msgText = `Method: ${currentMethod}<br/>`;
                    response.msgText += `Error: ${ex?.message}`;
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                    });
                    //#endregion Error
                }
            },
            allowOutsideClick: () => !Swal.isLoading(),
        };

        await Swal.fire(swalProperties);
        //#endregion show message 
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const userAccountApprovedPostAsync = async ({
    user = userModelGet({}),
    dtUsers = {},
    rowIndex = 0,
    auth = {},
    languageObj = GlobalFormats?.class(),
    subMethod = '',
}) => {
    const currentMethod = 'userAccountApprovedPostAsync';
    let response = responseGet();
    try {
        //#region variables
        let msgTextLocal = '';
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            //responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region show message
        //#region define message
        response = await userMessageGetAsync({
            msgText: '',
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            languageId: languageObj?.id,
            subMethod: currentMethod
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response
        }

        msgTextLocal = response?.result || '';
        //#endregion define message

        msgTextObj = {
            one: !user?.accountApproved ?
                `${messages?.doYouWantAuthorizeTheUser?.[languageObj?.id]}<br/><br/>` :
                `${messages?.doYouWantRemoveTheUserAuthorization?.[languageObj?.id]}<br/><br/>`,
            two: msgTextLocal,
            //three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            three: ``,
        };

        swalProperties = {
            icon: sweetAlert2?.icons?.warning,
            title: labels?.warning?.[languageObj?.id],
            html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
            timer: null,
            backdrop: true,
            confirmButtonColor: colors?.warningColorExp,
            confirmButtonText: labels?.yes?.[languageObj?.id],
            showCancelButton: true, //!Swal.isLoading(), //true,
            cancelButtonColor: colors?.successColorExp,
            cancelButtonText: labels?.no?.[languageObj?.id],
            showLoaderOnConfirm: true,
            didOpen: () => {
                Swal.hideLoading();
            },
            preConfirm: async () => {
                try {
                    Swal.getCancelButton().hidden = true;
                    Swal?.update({
                        icon: sweetAlert2?.icons?.info,
                        title: `${messages?.processing?.[languageObj?.id]}...`,
                        html: `${msgTextObj?.two}`,
                        showConfirmButton: false,
                    });

                    //#region user update
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    user = {
                        ...user,
                        accountApproved: !user.accountApproved,
                        accountApprovedDate: isUndNullEmp({ data: user?.accountApprovedUserId, subMethod: currentMethod, })?.result && !user?.accountApproved ?
                            new Date()?.toISOString() :
                            user?.accountApprovedDate,
                        accountApprovedUserId: isUndNullEmp({ data: user?.accountApprovedUserId, subMethod: currentMethod, })?.result && !user.accountApproved ?
                            auth?.user?.uid :
                            user?.accountApprovedUserId,
                    };

                    dataObj = {
                        user: user,
                        partialUpdate: true,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${user?.id}`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        return response;
                    }

                    user = response?.result?.userVzLa || {};
                    //#endregion user update

                    //#region update row data table
                    response = userProcessButtonsGet({
                        user: user,
                        languageObj: languageObj,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        return response;
                    }

                    const processButtonsData = response?.result || [];

                    dtUsers?.row(rowIndex)?.data(processButtonsData)?.draw(true);
                    //#endregion update row data table

                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 0,
                        msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                } catch (ex) {
                    //#region Error
                    response.isSuccess = false;
                    response.msgType = -1;
                    response.msgText = `Method: ${currentMethod}<br/>`;
                    response.msgText += `Error: ${ex?.message}`;
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                    });
                    //#endregion Error
                }
            },
            allowOutsideClick: () => !Swal.isLoading(),
        };

        await Swal.fire(swalProperties);
        //#endregion show message 
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const userEmailWellcomePostAsync = async ({
    user = userModelGet({}),
    dtUsers = {},
    rowIndex = 0,
    auth = {},
    languageObj = GlobalFormats?.class(),
    subMethod = '',
}) => {
    const currentMethod = 'userEmailWellcomePostAsync';
    let response = responseGet();
    try {
        //#region variables
        let msgTextLocal = '';
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            //responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region show message
        //#region define message
        response = await userMessageGetAsync({
            msgText: '',
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            languageId: languageObj?.id,
            subMethod: currentMethod
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response
        }

        msgTextLocal = response?.result || '';
        //#endregion define message

        msgTextObj = {
            one: `${messages?.doYouWantToSendTheWelcomeEmail?.[languageObj?.id]}<br/><br/>`,
            two: msgTextLocal,
            //three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            three: ``,
        };

        swalProperties = {
            icon: sweetAlert2?.icons?.warning,
            title: labels?.warning?.[languageObj?.id],
            html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
            timer: null,
            backdrop: true,
            confirmButtonColor: colors?.warningColorExp,
            confirmButtonText: labels?.yes?.[languageObj?.id],
            showCancelButton: true, //!Swal.isLoading(), //true,
            cancelButtonColor: colors?.successColorExp,
            cancelButtonText: labels?.no?.[languageObj?.id],
            showLoaderOnConfirm: true,
            didOpen: () => {
                Swal.hideLoading();
            },
            preConfirm: async () => {
                try {
                    Swal.getCancelButton().hidden = true;
                    Swal?.update({
                        icon: sweetAlert2?.icons?.info,
                        title: `${messages?.processing?.[languageObj?.id]}...`,
                        html: `${msgTextObj?.two}`,
                        showConfirmButton: false,
                    });

                    //#region user update
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        id: user?.id,
                        firstName: user?.firstName,
                        lastName: user?.lastName,
                        email: user?.email,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlAccounts}/${backend?.methods?.sendEmailWelcome}`
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        return response;
                    }
                    //#endregion user update

                    //#region update row data table
                    response = userProcessButtonsGet({
                        user: user,
                        languageObj: languageObj,
                        subMethod: currentMethod,
                    });

                    if (!response?.isSuccess || response?.isWarning) {
                        return response;
                    }

                    const processButtonsData = response?.result || [];

                    dtUsers?.row(rowIndex)?.data(processButtonsData)?.draw(true);
                    //#endregion update row data table

                    await sendMessageCloseCurrentWindowAsync({
                        msgType: 0,
                        msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                } catch (ex) {
                    //#region Error
                    response.isSuccess = false;
                    response.msgType = -1;
                    response.msgText = `Method: ${currentMethod}<br/>`;
                    response.msgText += `Error: ${ex?.message}`;
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                    });
                    //#endregion Error
                }
            },
            allowOutsideClick: () => !Swal.isLoading(),
        };

        await Swal.fire(swalProperties);
        //#endregion show message 
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const userAccountEnnableDisablePostAsync = async ({
    user = userModelGet({}),
    dtUsers = {},
    rowIndex = 0,
    auth = {},
    languageObj = GlobalFormats?.class(),
    subMethod = '',
}) => {
    const currentMethod = 'userAccountEnnableDisablePostAsync';
    let response = responseGet();
    try {
        //#region variables
        let propertyObj = {
            input: {},
            remark: '',
        };
        let isConfirmedTwo = true;
        let isDeniedTwo = false;
        let msgTextLocal = '';
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            //responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region show message
        //#region define message
        response = await userMessageGetAsync({
            msgText: '',
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            languageId: languageObj?.id,
            subMethod: currentMethod
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response
        }

        msgTextLocal = response?.result || '';
        //#endregion define message

        if (!isUndNullEmp({ data: user?.isDisabled, subMethod: currentMethod, })?.result && user?.isDisabled) {
            msgTextObj = {
                one: messages?.doYouWantToEnableTheAccountSeeTheAddedCommentOrCancel?.[languageObj?.id],
            };
            swalProperties = {
                icon: sweetAlert2?.icons?.info,
                title: labels?.information?.[languageObj?.id],
                html: `${msgTextObj?.one}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.enable?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.cancel?.[languageObj?.id],
                showDenyButton: true,
                denyButtonText: labels?.comment?.[languageObj?.id],
                denyButtonColor: colors?.infoColorExp,
                didOpen: () => {
                    Swal.hideLoading();
                },
            };

            const { isConfirmed, isDenied } = await Swal?.fire(swalProperties);

            isConfirmedTwo = isConfirmed;
            isDeniedTwo = isDenied;
        }

        //#region remark
        if (isDeniedTwo) {
            msgTextLocal = userMessageDisableDeleteGet({
                msgText: '',
                firstName: user?.firstName,
                lastName: user?.lastName,
                email: user?.email,
                dateTime: user?.isDisabledDate,
                remark: user?.isDisabledRemark,
                languageObj: languageObj,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;

            swalProperties = {
                icon: sweetAlert2?.icons?.info,
                title: labels?.remark?.[languageObj?.id],
                html: msgTextLocal,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.successColorExp,
                confirmButtonText: labels?.close?.[languageObj?.id],
                didOpen: () => {
                    Swal.hideLoading();
                },
            };

            Swal?.fire(swalProperties);
        }
        //#endregion remark

        //#region user update (remark)
        if (isConfirmedTwo) {
            msgTextObj = {
                one: isUndNullEmp({ data: user?.isDisabled, subMethod: currentMethod, })?.result || !user?.isDisabled ?
                    `${messages?.doYouWantToDisableTheAccount?.[languageObj?.id]}<br/><br/>` :
                    `${messages?.doYouWantToEnableTheAccount?.[languageObj?.id]}<br/><br/>`,

                two: msgTextLocal,
                //three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                three: ``,
            };

            //#region input / remark set
            propertyObj = {
                input: {},
                remark: '',
            };

            if (isUndNullEmp({ data: user?.isDisabled, subMethod: currentMethod, })?.result || !user?.isDisabled) {
                propertyObj.input = {
                    input: 'textarea',
                    inputPlaceholder: labels?.enterRemark?.[languageObj?.id],
                    inputValidator: (value) => {
                        if (!value) {
                            return messages?.youMustAddComment?.[languageObj?.id];
                        }
                        propertyObj.remark = value;
                    },
                };
            }
            //#endregion input / remark set

            swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: labels?.warning?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                ...propertyObj.input,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region user update
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                        };

                        user = {
                            ...user,
                            isDisabled: isUndNullEmp({ data: user?.isDisabled, subMethod: currentMethod, })?.result || !user?.isDisabled ? true : false,
                            isDisabledDate: new Date()?.toISOString(),
                            isDisabledUserId: auth?.user?.uid,
                            isDisabledRemark: propertyObj?.remark,
                        };

                        dataObj = {
                            user: user,
                            partialUpdate: true,
                            languageId: languageObj?.id,
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${user?.id}`,
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );

                        response = result?.data || {};

                        if (!response?.isSuccess || response?.isWarning) {
                            return response;
                        }

                        user = response?.result?.userVzLa || {}
                        //#endregion user update

                        //#region update row data table
                        response = userProcessButtonsGet({
                            user: user,
                            languageObj: languageObj,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            return response;
                        }

                        const processButtonsData = response?.result || [];

                        dtUsers?.row(rowIndex)?.data(processButtonsData)?.draw(true);
                        //#endregion update row data table

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
        }
        //#endregion user update (remark)
        //#endregion show message 
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const userAccountDeletePostAsync = async ({
    user = userModelGet({}),
    dtUsers = {},
    rowIndex = 0,
    auth = {},
    languageObj = GlobalFormats?.class(),
    subMethod = '',
}) => {
    const currentMethod = '';
    let response = responseGet();
    try {
        //#region variables
        let propertyObj = {
            input: {},
            remark: '',
        };
        let isConfirmedTwo = true;
        let isDeniedTwo = false;
        let msgTextLocal = '';
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        //responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            //responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region show message
        //#region define message
        response = await userMessageGetAsync({
            msgText: '',
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            languageId: languageObj?.id,
            subMethod: currentMethod
        });

        if (!response?.isSuccess || response?.isWarning) {
            return response
        }

        msgTextLocal = response?.result || '';
        //#endregion define message

        if (!isUndNullEmp({ data: user?.isDeleted, subMethod: currentMethod, })?.result && user?.isDeleted) {
            msgTextObj = {
                one: messages?.doYouWantToRestoreTheRecordViewTheAddedCommentOrCancel?.[languageObj?.id],
            };
            swalProperties = {
                icon: sweetAlert2?.icons?.info,
                title: labels?.information?.[languageObj?.id],
                html: `${msgTextObj?.one}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.restore?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.cancel?.[languageObj?.id],
                showDenyButton: true,
                denyButtonText: labels?.comment?.[languageObj?.id],
                denyButtonColor: colors?.infoColorExp,
                didOpen: () => {
                    Swal.hideLoading();
                },
            };

            const { isConfirmed, isDenied } = await Swal?.fire(swalProperties);

            isConfirmedTwo = isConfirmed;
            isDeniedTwo = isDenied;
        }

        //#region remark
        if (isDeniedTwo) {
            msgTextLocal = userMessageDisableDeleteGet({
                msgText: '',
                firstName: user?.firstName,
                lastName: user?.lastName,
                email: user?.email,
                dateTime: user?.isDeletedDate,
                remark: user?.isDeletedRemark,
                languageObj: languageObj,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;

            swalProperties = {
                icon: sweetAlert2?.icons?.info,
                title: labels?.remark?.[languageObj?.id],
                html: msgTextLocal,
                timer: null,
                backdrop: true,
                confirmButtonColor: colors?.successColorExp,
                confirmButtonText: labels?.close?.[languageObj?.id],
                didOpen: () => {
                    Swal.hideLoading();
                },
            };

            Swal?.fire(swalProperties);
        }
        //#endregion remark

        //#region user update (remark)
        if (isConfirmedTwo) {
            msgTextObj = {
                one: isUndNullEmp({ data: user?.isDeleted, subMethod: currentMethod, })?.result || !user?.isDeleted ?
                    `${messages?.areYouSureDeleteThis?.[languageObj?.id]}<br/><br/>` :
                    `${messages?.doYouWantToRestoreDeletedRegistry?.[languageObj?.id]}<br/><br/>`,

                two: msgTextLocal,
                //three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                three: ``,
            };

            //#region input / remark set
            propertyObj = {
                input: {},
                remark: '',
            };

            if (isUndNullEmp({ data: user?.isDeleted, subMethod: currentMethod, })?.result || !user?.isDeleted) {
                propertyObj.input = {
                    input: 'textarea',
                    inputPlaceholder: labels?.enterRemark?.[languageObj?.id],
                    inputValidator: (value) => {
                        if (!value) {
                            return messages?.youMustAddComment?.[languageObj?.id];
                        }
                        propertyObj.remark = value;
                    },
                };
            }
            //#endregion input / remark set

            swalProperties = {
                icon: sweetAlert2?.icons?.warning,
                title: labels?.warning?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                ...propertyObj.input,
                backdrop: true,
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region user update
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            },
                        };

                        user = {
                            ...user,
                            isDeleted: isUndNullEmp({ data: user?.isDeleted, subMethod: currentMethod, })?.result || !user?.isDeleted ? true : false,
                            isDeletedDate: new Date()?.toISOString(),
                            isDeletedUserId: auth?.user?.uid,
                            isDeletedRemark: propertyObj?.remark,
                        };

                        dataObj = {
                            user: user,
                            partialUpdate: true,
                            languageId: languageObj?.id,
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${user?.id}`,
                        };

                        result = await axios?.post(
                            dataObj?.url,
                            dataObj,
                            headerObj,
                        );

                        response = result?.data || {};

                        if (!response?.isSuccess || response?.isWarning) {
                            return response;
                        }

                        user = response?.result?.userVzLa || {}
                        //#endregion user update

                        //#region update row data table
                        response = userProcessButtonsGet({
                            user: user,
                            languageObj: languageObj,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            return response;
                        }

                        const processButtonsData = response?.result || [];

                        dtUsers?.row(rowIndex)?.data(processButtonsData)?.draw(true);
                        //#endregion update row data table

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
        }
        //#endregion user update (remark)
        //#endregion show message
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}
//#endregion show modal

//#region methods
//#region old code
// export const userRegisterResetPostAsync = async (user = {}, dtUsers, rowIndex = 0, auth = {}, subMethod = '',) => {
//     let response = responseGet();
//     try {
//         //#region update user

//         headerObj = {
//             headers: {
//                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
//             },
//         };

//         user?.roleId = '';
//         user?.emailVerified = false;
//         user?.accountApproved = false;

//         //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlUsers}/${user?.id}`, user, headerObj);
//         result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${user?.id}`, user, headerObj);
//         response = result.data;

//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         user = response.result.userVzLa;

//         //#endregion update user

//         //#region update row data table

//         response = userProcessButtonsGet(
//             user,
//             'userRegisterResetPostAsync'
//         );
//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         dtUsers.row(rowIndex).data(response.result)?.draw(true);

//         //#endregion update row data table
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: userRegisterResetPostAsync</br>`;
//         if (!isEmpty(subMethod)) {
//             response.msgText += `Sub method: ${subMethod}<br/>`;
//         }
//         response.msgText += `Error: ${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const setEmailVerificationPostAsync = async (user = {}, dtUsers, rowIndex = 0, auth = {}) => {
//     let response = responseGet();
//     try {
//         //#region update user

//         headerObj = {
//             headers: {
//                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
//             },
//         };

//         user.emailVerified = !user.emailVerified;
//         user.emailVerifiedDate = !user.emailVerified ? new Date()?.toISOString() : user.emailVerifiedDate;

//         //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlUsers}/${user.id}`, user, headerObj);
//         result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${user.id}`, user, headerObj);
//         response = result.data;

//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }
//         //user = response.result;
//         user = response.result.userVzLa;

//         //#endregion update user

//         //#region update row data table

//         response = userProcessButtonsGet(user, 'setEmailVerificationPostAsync');
//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         dtUsers.row(rowIndex).data(response.result)?.draw(true);

//         //#endregion update row data table
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: setEmailVerificationPostAsync</br>`;
//         response.msgText += `Error: ${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const emailVerificationSendPostAsync = async (user = {}, dtUsers, rowIndex = 0, auth = {}, subMethod = '',) => {
//     let response = responseGet();
//     try {
//         //#region update user

//         headerObj = {
//             headers: {
//                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
//             },
//         };

//         dataObj = {
//             id: user.id,
//             email: user.email,
//             firstName: user.firstName,
//             lastName: user.lastName,
//         };

//         //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlAccounts}/sendEmailVerification`, localData, headerObj);
//         result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlAccounts}/sendEmailVerification`, dataObj, headerObj);
//         response = result.data;

//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         user = response.result.userVzLa;

//         //#endregion update user

//         //#region update row data table

//         response = userProcessButtonsGet(
//             user,
//             'emailVerificationSendPostAsync'
//         );
//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         dtUsers.row(rowIndex).data(response.result)?.draw(true);

//         //#endregion update row data table
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: emailVerificationSendPostAsync</br>`;
//         if (!isEmpty(subMethod)) {
//             response.msgText += `Sub method: ${subMethod}<br/>`;
//         }
//         response.msgText += `Error: ${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const setAccountApprovedPostAsync = async (user = {}, dtUsers, rowIndex = 0, auth = {}, subMethod = '',) => {
//     let response = responseGet();
//     try {
//         //#region update user

//         headerObj = {
//             headers: {
//                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
//             },
//         };

//         dataObj = {
//             partialUpdate: true,
//             accountApproved: !user.accountApproved,
//             accountApprovedDate: ((isNull(user.accountApprovedUserId) || isEmpty(user.accountApprovedUserId)) && !user.accountApproved) ?
//                 new Date()?.toISOString() :
//                 user.accountApprovedDate,
//             accountApprovedUserId: ((isNull(user.accountApprovedUserId) || isEmpty(user.accountApprovedUserId)) && !user.accountApproved) ?
//                 auth?.user?.uid :
//                 user.accountApprovedUserId,
//         };

//         //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlUsers}/${user.id}`, localData, headerObj);
//         result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${user.id}`, dataObj, headerObj);
//         response = result.data;

//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         user = response.result.userVzLa;

//         //#endregion update user

//         //#region update row data table

//         response = userProcessButtonsGet(user, 'setAccountApprovedPostAsync');
//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         dtUsers.row(rowIndex).data(response.result)?.draw(true);

//         //#endregion update row data table
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: setAccountApprovedPostAsync</br>`;
//         if (!isEmpty(subMethod)) {
//             response.msgText += `Sub method: ${subMethod}<br/>`;
//         }
//         response.msgText += `Error: ${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// export const userByIdGetAsync = async (userId = '', methodName = '', auth = {}) => {
//     let response = responseGet();
//     try {
//         headerObj = {
//             headers: {
//                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
//             },
//         };
//         //result = await axios?.get(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlUsers}/${userId}`, headerObj);
//         result = await axios?.get(`${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${userId}`, headerObj);
//         response = result.data;
//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: ${methodName}</br>`;
//         response.msgText += `Sub method: localUserGetByIdAsync</br>`;
//         response.msgText += `Error: ${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

export const userByIdGetAsync = async ({
    id = '',
    auth = {},
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'userByIdGetAsync';
    let response = responseGet();
    try {
        //#region variables
        //#region response is warning
        let responseIsWarning = responseGet();
        responseIsWarning.msgType = 1;
        responseIsWarning.isWarning = true;
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region check structure
        if (isUndNullEmp({ data: id, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Error: User Id. ${messages?.itIsRequired?.[languageId]}`;
            return responseIsWarning;
        } else if (isUndNullEmp({ data: auth?.user, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Error: Auth / user. ${messages?.itIsRequired?.[languageId]}`;
            return responseIsWarning;
        } else if (isUndNullEmp({ data: auth?.user?.tokenVzLaCondominios?.token, subMethod: currentMethod, })?.result) {
            responseIsWarning.msgText += `Error: Auth / user / tokenVzLaCondominios / token. ${messages?.itIsRequired?.[languageId]}`;
            return responseIsWarning;
        }
        //#endregion check structure

        //#region data get
        headerObj = {
            headers: {
                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                languageId: languageId,
            },
            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${id}`,
        };

        result = await axios?.get(
            headerObj?.url,
            headerObj,
        );

        response = result?.data;
        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }
        //#endregion data get
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const localUserCreateWithIdAsync = async (userId = '', user = {}, subMethod = '',) => {
    const currentMethod = 'localUserCreateWithIdAsync';
    let response = responseGet();
    try {
        user.withId = userId;

        //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlUsers}/${userId}`);
        result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/`, user);
        response = result.data;
        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const localUserUpdateWithIdAsync = async (userId = '', user = {}, partial = false, subMethod = '',) => {
    const currentMethod = 'localUserUpdateWithIdAsync';
    let response = responseGet();
    try {
        if (partial) {
            user.partialUpdate = true;
        }

        //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlUsers}/${userId}`, user);
        result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${userId}`, user);
        response = result.data;
        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

export const userProcessButtonsGet = ({
    user = userModelGet({}),
    languageObj = GlobalFormats?.class(),
    subMethod = '',
}) => {
    const currentMethod = 'userProcessButtonsGet';
    let response = responseGet();
    try {
        //#region variables
        let processButtonsLocal = [];
        let isDeletedTypeLocal = 0;
        let isDeletedLabelLocal = '';

        let isDisabledTypeLocal = 0;
        let isDisabledLabelLocal = '';

        let emailVerifiedTypeLocal = 0;
        let emailVerifiedLabelLocal = '';

        let accountTypeLocal = 0;
        let accountTypeLabelLocal = '';

        let roleTypeLocal = 0;
        let roleLabelLocal = '';

        let dtRow = [];
        const dateTime = {
            dateFormat: languageObj?.format?.date.f1, //globalSettings?.react?.tempusDominus?.format?.date?.dmy,
            timeFormat: languageObj?.format?.time.type, //globalSettings?.react?.tempusDominus?.format?.date?.dmy,
        };
        //#endregion variables

        //#region processButtos get
        processButtonsLocal = [
            {
                isVisible: true,
                showDivider: true,
                isEnabled: true,
                methodName: backend?.methods?.restoreRegister,
                icon: icons?.userClock,
                label: labels?.restoreRegistry?.[languageObj?.id],
            },
            {
                isVisible: true,
                showDivider: false,
                isEnabled: true,
                methodName: backend?.methods?.emailConfirmSend,
                icon: icons?.edit,
                label: labels?.sendEmailConfirmation?.[languageObj?.id],
            },
            {
                isVisible: true,
                showDivider: false,
                isEnabled: true,
                methodName: backend?.methods?.authUser,
                icon: icons?.userTag,
                label: labels?.authorizeUser?.[languageObj?.id],
            },
            {
                isVisible: true,
                showDivider: true,
                isEnabled: true,
                methodName: backend?.methods?.wellEmail,
                icon: icons?.envelope,
                label: labels?.welcomeEmail?.[languageObj?.id],
            },
            {
                isVisible: true,
                showDivider: true,
                isEnabled: true,
                methodName: backend?.methods?.enableDisableAccount,
                icon: icons?.toggleOn,
                label: isUndNullEmp({ data: user?.isDisabled, subMethod: currentMethod, })?.result || !user?.isDisabled ?
                    labels?.disableAccount?.[languageObj?.id] :
                    labels?.enableAccount?.[languageObj?.id],
            },
            {
                isVisible: true,
                showDivider: false,
                isEnabled: true,
                methodName: backend?.methods?.deleteAccount,
                icon: isUndNullEmp({ data: user?.isDeleted, subMethod: currentMethod, })?.result || !user?.isDeleted ? icons?.trash : icons?.undo,
                label: isUndNullEmp({ data: user?.isDeleted, subMethod: currentMethod, })?.result || !user?.isDeleted ?
                    labels?.deleteAccount?.[languageObj?.id] :
                    labels?.restoreAccount?.[languageObj?.id],
            },
        ];
        //#endregion processButtons get

        //#region get row data
        isDeletedTypeLocal = isUndNullEmp({ data: user?.isDeleted, subMethod: currentMethod, })?.result || !user.isDeleted ? 5 : 1;
        isDeletedLabelLocal = isUndNullEmp({ data: user?.isDeleted, subMethod: currentMethod, })?.result || !user.isDeleted ? `<i class='${icons?.square}'></i>` : `<i class='${icons?.check}'></i>`;

        isDisabledTypeLocal = isUndNullEmp({ data: user?.isDisabled, subMethod: currentMethod, })?.result || !user.isDisabled ? 5 : 1;
        isDisabledLabelLocal = isUndNullEmp({ data: user?.isDisabled, subMethod: currentMethod, })?.result || !user?.isDisabled ? `<i class='${icons?.square}'></i>` : `<i class='${icons?.check}'></i>`;

        emailVerifiedTypeLocal = isUndNullEmp({ data: user?.emailVerified, subMethod: currentMethod, })?.result || !user?.emailVerified ? 5 : 0;
        emailVerifiedLabelLocal = isUndNullEmp({ data: user?.emailVerified, subMethod: currentMethod, })?.result || !user?.emailVerified ? `<i class='${icons?.square}'></i>` : `<i class='${icons?.check}'></i>`;

        accountTypeLocal = isUndNullEmp({ data: user?.accountApproved, subMethod: currentMethod, })?.result || !user?.accountApproved ? 5 : 0;
        accountTypeLabelLocal = isUndNullEmp({ data: user?.accountApproved, subMethod: currentMethod, })?.result || !user?.accountApproved ? `<i class='${icons?.square}'></i>` : `<i class='${icons?.check}'></i>`;

        roleTypeLocal = isUndNullEmp({ data: user?.roleId, subMethod: currentMethod, })?.result ? 5 : 0;
        roleLabelLocal = isUndNullEmp({ data: user?.roleId, subMethod: currentMethod, })?.result ? `<i class='${icons?.square}'></i>` : `<i class='${icons?.check}'></i>`;

        dtRow = [
            user?.email,
            dateTimeFormatGlobalSet({
                date: user?.created,
                type: dateTime?.dateFormat,
                format: dateTime?.timeFormat,
                addTime: false,
                secondsShow: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result,
            setBadgeStatusGeneric({
                type: isDeletedTypeLocal,
                value: isDeletedLabelLocal,
                subMethod: currentMethod,
            }),
            setBadgeStatusGeneric({
                type: isDisabledTypeLocal,
                value: isDisabledLabelLocal,
                subMethod: currentMethod,
            }),
            setBadgeStatusGeneric({
                type: emailVerifiedTypeLocal,
                value: emailVerifiedLabelLocal,
                subMethod: currentMethod,
            }),
            setBadgeStatusGeneric({
                type: accountTypeLocal,
                value: accountTypeLabelLocal,
                subMethod: currentMethod,
            }),
            setBadgeStatusGeneric({
                type: roleTypeLocal,
                value: roleLabelLocal,
                subMethod: currentMethod,
            }),
            buttonProcessGet({
                id: user?.id,
                description: user?.email,
                showDetails: false,
                labelDetails: '',
                enabledDetails: false,
                showEdit: true,
                labelEdit: labels?.edit?.[languageObj?.id],
                enabledEdit: true,
                showDelete: false,
                labelDelete: '',
                enabledDelete: false,
                processButtons: processButtonsLocal,
                subMethod: currentMethod,
            })?.result,
        ];
        //#endregion get row data

        //#region final data set
        response.result = dtRow;
        //#endregion final data set
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

//#region old code
// const localSendEmailWelcomeAsync = async (user = {}, dtUsers, rowIndex = 0, auth = {}, subMethod = '',) => {
//     let response = responseGet();
//     try {
//         headerObj = {
//             headers: {
//                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
//             },
//         };

//         dataObj = {
//             id: user.id,
//             firstName: user.firstName,
//             lastName: user.lastName,
//             email: user.email,
//         };

//         //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlAccounts}/sendWelcomeEmail`, localData, headerObj);
//         result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlAccounts}/sendWelcomeEmail`, dataObj, headerObj);
//         response = result.data;
//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         response = userProcessButtonsGet(
//             user,
//             'localSendEmailWelcomeAsync'
//         );
//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         dtUsers.row(rowIndex).data(response.result)?.draw(true);
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: localSendEmailWelcomeAsync</br>`;
//         if (!isEmpty(subMethod)) {
//             response.msgText += `Sub method: ${subMethod}<br/>`;
//         }
//         response.msgText += `Error: ${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// const localEnableDisableAccountPostAsync = async (user = {}, remark = '', dtUsers, rowIndex = 0, auth = {}, subMethod = '',) => {
//     let response = responseGet();
//     try {
//         headerObj = {
//             headers: {
//                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
//             },
//         };

//         dataObj = {
//             partialUpdate: true,
//             isDisabled: (isUndefined(user.isDisabled) || isNull(user.isDisabled) || !user.isDisabled) ? true : false,
//             isDisabledDate: new Date()?.toISOString(),
//             isDisabledUserId: auth?.user?.uid,
//             isDisabledRemark: remark,
//         }

//         //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlUsers}/${user.id}`, localData, headerObj);
//         result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${user.id}`, dataObj, headerObj);
//         response = result.data;

//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         //#region old code

//         // user.isDisabled = localData.isDisabled;
//         // user.isDisabledDate = localData.isDeletedDate;
//         // user.isDisabledRemark = localData.isDisabledRemark;

//         //#endregion old code

//         user = response.result.userVzLa

//         response = userProcessButtonsGet(user, 'localEnableDisableAccountPostAsync');
//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         dtUsers.row(rowIndex).data(response.result)?.draw(true);
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: localEnableDisableAccountPostAsync</br>`;
//         if (!isEmpty(subMethod)) {
//             response.msgText += `Sub method: ${subMethod}<br/>`;
//         }
//         response.msgText += `Error: ${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

//#region old code
// const localUserDeletePostAsync = async (user = {}, remark = '', dtUsers, rowIndex = 0, auth = {}, subMethod = '',) => {
//     let response = responseGet();
//     try {
//         headerObj = {
//             headers: {
//                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
//             },
//         };

//         dataObj = {
//             partialUpdate: true,
//             isDeleted: (isUndefined(user.isDeleted) || isNull(user.isDeleted) || !user.isDeleted) ? true : false,
//             isDeletedDate: new Date()?.toISOString(),
//             isDeletedUserId: auth?.user?.uid,
//             isDeletedRemark: remark,
//         }

//         //result = await axios?.post(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlUsers}/${user.id}`, localData, headerObj);
//         result = await axios?.post(`${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}/${user.id}`, dataObj, headerObj);
//         response = result.data;

//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         //#region old code

//         // user.isDeleted = localData.isDeleted;
//         // user.isDeletedDate = localData.isDeletedDate;
//         // user.isDeletedRemark = localData.isDeletedRemark;

//         //#endregion old code

//         user = response.result.userVzLa;

//         response = userProcessButtonsGet(user, 'localUserDeletePostAsync');
//         if (!response?.isSuccess || response?.isWarning) {
//             return response;
//         }

//         dtUsers.row(rowIndex).data(response.result)?.draw(true);
//     } catch (ex) {
//         response.isSuccess = false;
//         response.msgType = -1;
//         response.msgText = `Method: localUserDeletePostAsync</br>`;
//         if (!isEmpty(subMethod)) {
//             response.msgText += `Sub method: ${subMethod}<br/>`;
//         }
//         response.msgText += `Error: ${ex?.message}`;
//     }
//     return response;
// }
//#endregion old code

const userMessageGetAsync = async ({
    msgText = '',
    firstName = '',
    lastName = '',
    email = '',
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'userMessageGetAsync';
    let response = responseGet();
    try {
        response.result = `<div class='table-responsive' style='font-size:14px'>`;
        if (!isUndNullEmp({ data: msgText, subMethod: currentMethod, })?.result) {
            response.result += `   <div>${msgText}</div>`;
            response.result += `  <br/>`;
        }
        response.result += `    <table class='table table-sm'>`;
        response.result += `       <col width='20px'/>`;
        response.result += `       <col width='80px'/>`;
        response.result += `       <tbody class='text-left'>`;
        response.result += `           <tr>`;
        response.result += `               <td>${labels?.user?.[languageId]}:</td>`;
        response.result += `               <td><b>${firstName}, ${lastName}</b></td>`;
        response.result += `           </tr>`;
        response.result += `           <tr>`;
        response.result += `               <td>${labels?.email?.[languageId]}:</td>`;
        response.result += `               <td><b>${email}</b></td>`;
        response.result += `           </tr>`;
        response.result += `       </tbody>`;
        response.result += `   </table>`;
        response.result += `</div>`;
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            response.msgText += `Sub method: ${subMethod}<br>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}

const userMessageDisableDeleteGet = ({
    msgText = '',
    firstName = '',
    lastName = '',
    email = '',
    dateTime = new Date()?.toISOString(),
    remark = '',
    languageObj = GlobalFormats?.class(),
    languageId = 'en',
    subMethod = '',
}) => {
    const currentMethod = 'userMessageDisableDeleteGet';
    let response = responseGet();
    try {
        response.result = `<div class='table-responsive' style='font-size:14px'>`;
        if (!isUndNullEmp({ data: msgText, subMethod: currentMethod, })?.result) {
            response.result += `   <div>${msgText}</div>`;
            response.result += `  <br/>`;
        }
        response.result += `    <table class='table table-sm'>`;
        response.result += `       <col width='20px'/>`;
        response.result += `       <col width='80px'/>`;
        response.result += `       <tbody class='text-left'>`;
        response.result += `           <tr>`;
        response.result += `               <td>${labels?.user?.[languageId]}:</td>`;
        response.result += `               <td><b>${firstName}, ${lastName}</b></td>`;
        response.result += `           </tr>`;
        response.result += `           <tr>`;
        response.result += `               <td>${labels?.email?.[languageId]}:</td>`;
        response.result += `               <td><b>${email}</b></td>`;
        response.result += `           </tr>`;
        response.result += `           <tr>`;
        //response.result += `               <td>${labels?.details?.[languageId]}</td>`;
        response.result += `               <td><hr style='border: none; border-top: 1px dotted'/></td>`;
        response.result += `               <td><hr style='border: none; border-top: 1px dotted'/></td>`;
        response.result += `           </tr>`;
        response.result += `           <tr>`;
        response.result += `               <td>${labels?.date?.[languageId]}:</td>`;
        response.result += `               <td><b>${dateTimeFormatGlobalSet({
            date: dateTime,
            type: languageObj?.format?.date?.f1,
            format: languageObj?.format?.time?.type,
            addTime: false,
            secondsShow: false,
            languageId: languageObj?.id,
            subMethod: currentMethod,
        })?.result}</b></td>`;
        response.result += `           </tr>`;
        response.result += `           <tr>`;
        response.result += `               <td>${labels?.comment?.[languageId]}:</td>`;
        response.result += `               <td><b>${remark}</b></td>`;
        response.result += `           </tr>`;
        response.result += `       </tbody>`;
        response.result += `   </table>`;
        response.result += `</div>`;
    } catch (ex) {
        response.msgType = -1;
        response.isSuccess = false;
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod, })?.result) {
            response.msgText += `Sub method: ${subMethod}<br>`;
        }
        response.msgText += `Error: ${ex?.message}`;
    }
    return response;
}
//#endregion methods